export default [{
        path: '/management',
        name: 'management',
        component: () =>
            import ('@/views/management/Management.vue'),
        meta: {
            pageTitle: 'Management',
            breadcrumb: [{
                text: 'Management',
                active: true,
            }, ],
        },

    },
    {
        path: '/account/password-change',
        name: 'account-password-change',
        component: () =>
            import ('@/views/management/account/PasswordChange.vue'),
        meta: {
            pageTitle: 'Account',
            breadcrumb: [{
                text: 'Account',
                active: true,
            }, ],
        },

    },
    {
        path: '/users',
        name: 'users',
        component: () =>
            import ('@/views/management/users/Users.vue'),
        meta: {
            pageTitle: 'Users',
            breadcrumb: [{
                text: 'Users',
                active: true,
            }, ],
        },
    },
    {
        path: '/users/create',
        name: 'users',
        component: () =>
            import ('@/views/management/users/UserCreate.vue'),
        meta: {
            pageTitle: 'Users',
            breadcrumb: [{
                text: 'Users',
                active: true,
            }, ],
        },
    },
    {
        path: '/categories',
        name: 'categories',
        component: () =>
            import ('@/views/management/categories/Categories.vue'),
        meta: {
            pageTitle: 'Categories',
            breadcrumb: [{
                text: 'Categories',
                active: true,
            }, ],
        },
    },
    {
        path: '/categories/create',
        name: 'categories-create',
        component: () =>
            import ('@/views/management/categories/CategoryCreate.vue'),
        meta: {
            pageTitle: 'Categories',
            breadcrumb: [{

                text: 'Categories',
            }, {
                text: 'Create',
                active: true,
            }, ],
        },
    },
    {
        path: '/categories/edit/:slugParam',
        name: 'categories-edit',
        component: () =>
            import ('@/views/management/categories/CategoryEdit.vue'),
        meta: {
            pageTitle: 'Categories',
            breadcrumb: [{

                text: 'Categories',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/categories/create/translation/:idParam',
        name: 'categories-create-translation',
        component: () =>
            import ('@/views/management/categories/CategoryCreateTranslation.vue'),
        meta: {
            pageTitle: 'Categories',
            breadcrumb: [{

                text: 'Categories',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/categories',
        name: 'contents-categories',
        component: () =>
            import ('@/views/management/contents/ContentsCategories.vue'),
        meta: {
            pageTitle: 'Contents',
            breadcrumb: [{
                text: 'Contents',
            }, {
                text: 'Categories',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/categories/:slugParam',
        name: 'contents-categories-list',
        component: () =>
            import ('@/views/management/contents/Contents.vue'),
        meta: {
            pageTitle: 'ContentsList',
            breadcrumb: [{
                text: 'Contents',
            }, {
                text: 'Categories',
            }, {
                text: 'List',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/create/:slugParam',
        name: 'contents-create',
        component: () =>
            import ('@/views/management/contents/ContentCreate.vue'),
        meta: {
            pageTitle: 'Contents',
            breadcrumb: [{

                text: 'Contents',
            }, {
                text: 'Create',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/edit/:slugParam',
        name: 'contents-edit',
        component: () =>
            import ('@/views/management/contents/ContentEdit.vue'),
        meta: {
            pageTitle: 'Contents',
            breadcrumb: [{

                text: 'Contents',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/contents/create/translation/:slugParam',
        name: 'contents-create-translation',
        component: () =>
            import ('@/views/management/contents/ContentCreateTranslation.vue'),
        meta: {
            pageTitle: 'Contents',
            breadcrumb: [{

                text: 'Contents',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/our-leaders',
        name: 'our-leaders',
        component: () =>
            import ('@/views/management/our-leaders/OurLeaders.vue'),
        meta: {
            pageTitle: 'Our Leaders',
            breadcrumb: [{
                text: 'Our Leaders',
                active: true,
            }, ],
        },
    },
    {
        path: '/our-leaders/create',
        name: 'our-leaders-create',
        component: () =>
            import ('@/views/management/our-leaders/OurLeaderCreate.vue'),
        meta: {
            pageTitle: 'Our Leaders',
            breadcrumb: [{

                text: 'Our Leaders',
            }, {
                text: 'Create',
                active: true,
            }, ],
        },
    },
    {
        path: '/our-leaders/edit/:slugParam',
        name: 'our-leaders-edit',
        component: () =>
            import ('@/views/management/our-leaders/OurLeaderEdit.vue'),
        meta: {
            pageTitle: 'Our Leaders',
            breadcrumb: [{

                text: 'Our Leaders',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/our-leaders/create/translation/:slugParam',
        name: 'our-leaders-create-translation',
        component: () =>
            import ('@/views/management/our-leaders//OurLeaderCreateTranslation.vue'),
        meta: {
            pageTitle: 'Our Leaders',
            breadcrumb: [{

                text: 'Our Leaders',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/sliders/home',
        name: 'sliders-home',
        component: () =>
            import ('@/views/management/sliders/home/HomeSliders.vue'),
        meta: {
            pageTitle: 'Home Slider',
            breadcrumb: [{

                text: 'Home Slider',
                active: true,
            }, ],
        },
    },
    {
        path: '/sliders/home/create',
        name: 'sliders-home-create',
        component: () =>
            import ('@/views/management/sliders/home/HomeSliderCreate.vue'),
        meta: {
            pageTitle: 'Home Slider',
            breadcrumb: [{

                    text: 'Home Slider',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/sliders/home/edit/:idParam',
        name: 'sliders-home-edit',
        component: () =>
            import ('@/views/management/sliders/home/HomeSliderEdit.vue'),
        meta: {
            pageTitle: 'Home Slider',
            breadcrumb: [{

                text: 'Home Slider',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/sliders/home/create/translation/:idParam',
        name: 'sliders-home-create-translation',
        component: () =>
            import ('@/views/management/sliders/home/HomeSliderCreateTranslation.vue'),
        meta: {
            pageTitle: 'Home Slider',
            breadcrumb: [{

                text: 'Events',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/sliders/highlights',
        name: 'sliders-highlights',
        component: () =>
            import ('@/views/management/sliders/highlights/HighlightsSlider.vue'),
        meta: {
            pageTitle: 'Highlights',
            breadcrumb: [{
                text: 'Highlights',
            }, ],
        },
    },
    {
        path: '/sliders/programs',
        name: 'sliders-programs',
        component: () =>
            import ('@/views/management/sliders/programs/ProgramsSlider.vue'),
        meta: {
            pageTitle: 'Programs',
            breadcrumb: [{
                text: 'Programs',
            }, ],
        },
    },
    {
        path: '/sliders/interesteds',
        name: 'sliders-interesteds',
        component: () =>
            import ('@/views/management/sliders/interesteds/InterestedsSlider.vue'),
        meta: {
            pageTitle: 'Interesteds',
            breadcrumb: [{
                text: 'Interesteds',
            }, ],
        },
    },
    {
        path: '/sliders/podcasts',
        name: 'sliders-podcasts',
        component: () =>
            import ('@/views/management/sliders/podcasts/PodcastsSlider.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{
                text: 'Podcasts',
            }, ],
        },
    },
    {
        path: '/events',
        name: 'events',
        component: () =>
            import ('@/views/management/events/Events.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [{

                text: 'Events',
                active: true,
            }, ],
        },
    },
    {
        path: '/events/create',
        name: 'events-create',
        component: () =>
            import ('@/views/management/events/EventCreate.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [{

                    text: 'Events',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/events/edit/:slugParam',
        name: 'events-edit',
        component: () =>
            import ('@/views/management/events/EventEdit.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [{

                text: 'Events',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/events/create/translation/:slugParam',
        name: 'events-create-translation',
        component: () =>
            import ('@/views/management/events/EventCreateTranslation.vue'),
        meta: {
            pageTitle: 'Events',
            breadcrumb: [{

                text: 'Events',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/podcasts',
        name: 'podcasts',
        component: () =>
            import ('@/views/management/podcasts/Podcasts.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{

                text: 'Podcasts',
                active: true,
            }, ],
        },
    },
    {
        path: '/podcasts/create',
        name: 'podcasts-create',
        component: () =>
            import ('@/views/management/podcasts/PodcastCreate.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{

                    text: 'Podcasts',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/podcasts/edit/:slugParam',
        name: 'podcasts-edit',
        component: () =>
            import ('@/views/management/podcasts/PodcastEdit.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{

                text: 'Podcasts',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/podcasts/create/translation/:slugParam',
        name: 'podcasts-create-translation',
        component: () =>
            import ('@/views/management/podcasts/PodcastCreateTranslation.vue'),
        meta: {
            pageTitle: 'Podcasts',
            breadcrumb: [{

                text: 'Podcasts',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    }, {
        path: '/galleries',
        name: 'galleries',
        component: () =>
            import ('@/views/management/galleries/Galleries.vue'),
        meta: {
            pageTitle: 'Galleries',
            breadcrumb: [{

                text: 'Galleries',
                active: true,
            }, ],
        },
    },
    {
        path: '/galleries/create',
        name: 'galleries-create',
        component: () =>
            import ('@/views/management/galleries/GalleryCreate.vue'),
        meta: {
            pageTitle: 'Galleries',
            breadcrumb: [{

                    text: 'Galleries',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/galleries/edit/:slugParam',
        name: 'galleries-edit',
        component: () =>
            import ('@/views/management/galleries/GalleryEdit.vue'),
        meta: {
            pageTitle: 'Galleries',
            breadcrumb: [{

                text: 'Galleries',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/galleries/create/translation/:slugParam',
        name: 'galleries-create-translation',
        component: () =>
            import ('@/views/management/galleries/GalleryCreateTranslation.vue'),
        meta: {
            pageTitle: 'Galleries',
            breadcrumb: [{

                text: 'Galleries',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/books',
        name: 'books',
        component: () =>
            import ('@/views/management/books/Books.vue'),
        meta: {
            pageTitle: 'Books',
            breadcrumb: [{

                text: 'Books',
                active: true,
            }, ],
        },
    },
    {
        path: '/books/create',
        name: 'books-create',
        component: () =>
            import ('@/views/management/books/BookCreate.vue'),
        meta: {
            pageTitle: 'Books',
            breadcrumb: [{

                    text: 'Books',
                    active: true,
                },
                {

                    text: 'Create',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/books/edit/:idParam',
        name: 'books-edit',
        component: () =>
            import ('@/views/management/books/BookEdit.vue'),
        meta: {
            pageTitle: 'Books',
            breadcrumb: [{

                text: 'Books',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/books/create/translation/:idParam',
        name: 'books-create-translation',
        component: () =>
            import ('@/views/management/books/BookCreateTranslation.vue'),
        meta: {
            pageTitle: 'Books',
            breadcrumb: [{

                text: 'Books',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/contacts',
        name: 'forms-contacts',
        component: () =>
            import ('@/views/management/forms/Contacts.vue'),
        meta: {
            pageTitle: 'Contacts',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Contacts',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/participants',
        name: 'forms-participants',
        component: () =>
            import ('@/views/management/forms/Participants.vue'),
        meta: {
            pageTitle: 'Participants',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Participants',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/newsletters',
        name: 'forms-newsletters',
        component: () =>
            import ('@/views/management/forms/Newsletters.vue'),
        meta: {
            pageTitle: 'Newsletters',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'Newsletters',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/company-activities',
        name: 'forms-company-activities',
        component: () =>
            import ('@/views/management/forms/CompanyActivities.vue'),
        meta: {
            pageTitle: 'CompanyActivities',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'CompanyActivities',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/company-activities',
        name: 'forms-company-activities',
        component: () =>
            import ('@/views/management/forms/CompanyActivities.vue'),
        meta: {
            pageTitle: 'CompanyActivities',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'CompanyActivities',
                active: true,
            }, ],
        },
    },
    {
        path: '/forms/explicit-consent-texts',
        name: 'forms-explicit-consent-texts',
        component: () =>
            import ('@/views/management/forms/ExplicitConsentTexts.vue'),
        meta: {
            pageTitle: 'ExplicitConsentTextForms',
            breadcrumb: [{

                text: 'Forms',
            }, {
                text: 'ExplicitConsentTextForms',
                active: true,
            }, ],
        },
    },
    {
        path: '/medias',
        name: 'medias',
        component: () =>
            import ('@/views/management/medias/Medias.vue'),
        meta: {
            pageTitle: 'Medias',
            breadcrumb: [{

                text: 'Medias',
            }, {
                text: 'Medias',
                active: true,
            }, ],
        },
    },
    {
        path: '/newsletters',
        name: 'newsletters',
        component: () =>
            import ('@/views/management/newsletters/Newsletters.vue'),
        meta: {
            pageTitle: 'Newsletters',
            breadcrumb: [{

                text: 'Newsletters',
            }, {
                text: 'Newsletters',
                active: true,
            }, ],
        },
    },
    {
        path: '/popups',
        name: 'popups',
        component: () =>
            import ('@/views/management/popups/Popups.vue'),
        meta: {
            pageTitle: 'Popups',
            breadcrumb: [{

                text: 'Popups',
            }, {
                text: 'Popups',
                active: true,
            }, ],
        },
    },
    {
        path: '/popups/create',
        name: 'popups-create',
        component: () =>
            import ('@/views/management/popups/PopupCreate.vue'),
        meta: {
            pageTitle: 'Popups',
            breadcrumb: [{

                text: 'Popups',
            }, {
                text: 'Create',
                active: true,
            }, ],
        },
    },
    {
        path: '/popups/edit/:idParam',
        name: 'popups-edit',
        component: () =>
            import ('@/views/management/popups/PopupEdit.vue'),
        meta: {
            pageTitle: 'Popups',
            breadcrumb: [{

                text: 'Popups',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/popups/create/translation/:idParam',
        name: 'popups-create-translation',
        component: () =>
            import ('@/views/management/popups/PopupCreateTranslation.vue'),
        meta: {
            pageTitle: 'Popups',
            breadcrumb: [{

                text: 'Popups',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/catalog/categories',
        name: 'catalog-categories',
        component: () =>
            import ('@/views/management/catalog/categories/Categories.vue'),
        meta: {
            pageTitle: 'CatalogCategories',
            breadcrumb: [{

                text: 'CatalogCategories',
            }, {
                text: 'CatalogCategories',
                active: true,
            }, ],
        },
    },
    {
        path: '/catalog/categories/edit/:idParam',
        name: 'catalog-categories-edit',
        component: () =>
            import ('@/views/management/catalog/categories/CategoryEdit.vue'),
        meta: {
            pageTitle: 'CatalogCategories',
            breadcrumb: [{

                text: 'CatalogCategories',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/catalog/categories/create/translation/:idParam',
        name: 'catalog-categories-create-translation',
        component: () =>
            import ('@/views/management/catalog/categories/CategoryCreateTranslation.vue'),
        meta: {
            pageTitle: 'CatalogCategories',
            breadcrumb: [{

                text: 'CatalogCategories',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/catalog/sub-categories',
        name: 'catalog-sub-categories',
        component: () =>
            import ('@/views/management/catalog/sub-categories/SubCategories.vue'),
        meta: {
            pageTitle: 'CatalogSubCategories',
            breadcrumb: [{

                text: 'CatalogSubCategories',
            }, {
                text: 'CatalogSubCategories',
                active: true,
            }, ],
        },
    },
    {
        path: '/catalog/sub-categories/edit/:idParam',
        name: 'catalog-sub-categories-edit',
        component: () =>
            import ('@/views/management/catalog/sub-categories/SubCategoryEdit.vue'),
        meta: {
            pageTitle: 'CatalogSubCategories',
            breadcrumb: [{

                text: 'CatalogSubCategories',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/catalog/sub-categories/create/translation/:idParam',
        name: 'catalog-sub-categories-create-translation',
        component: () =>
            import ('@/views/management/catalog/sub-categories/SubCategoryCreateTranslation.vue'),
        meta: {
            pageTitle: 'CatalogSubCategories',
            breadcrumb: [{

                text: 'CatalogSubCategories',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/catalog/brands',
        name: 'catalog-brands',
        component: () =>
            import ('@/views/management/catalog/brands/Brands.vue'),
        meta: {
            pageTitle: 'CatalogBrands',
            breadcrumb: [{

                text: 'CatalogBrands',
            }, {
                text: 'CatalogBrands',
                active: true,
            }, ],
        },
    },
    {
        path: '/catalog/brands/edit/:idParam',
        name: 'catalog-brands-edit',
        component: () =>
            import ('@/views/management/catalog/brands/BrandEdit.vue'),
        meta: {
            pageTitle: 'CatalogBrands',
            breadcrumb: [{

                text: 'CatalogBrands',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/catalog/brands/create/translation/:idParam',
        name: 'catalog-brands-create-translation',
        component: () =>
            import ('@/views/management/catalog/brands/BrandCreateTranslation.vue'),
        meta: {
            pageTitle: 'CatalogBrands',
            breadcrumb: [{

                text: 'CatalogBrands',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },
    {
        path: '/catalog/products',
        name: 'catalog-products',
        component: () =>
            import ('@/views/management/catalog/products/Products.vue'),
        meta: {
            pageTitle: 'CatalogProducts',
            breadcrumb: [{

                text: 'CatalogProducts',
            }, {
                text: 'CatalogProducts',
                active: true,
            }, ],
        },
    },
    {
        path: '/catalog/products/edit/:idParam',
        name: 'catalog-products-edit',
        component: () =>
            import ('@/views/management/catalog/products/ProductEdit.vue'),
        meta: {
            pageTitle: 'CatalogProducts',
            breadcrumb: [{

                text: 'CatalogProducts',
            }, {
                text: 'Edit',
                active: true,
            }, ],
        },
    },
    {
        path: '/catalog/products/create/translation/:idParam',
        name: 'catalog-products-create-translation',
        component: () =>
            import ('@/views/management/catalog/products/ProductCreateTranslation.vue'),
        meta: {
            pageTitle: 'CatalogProducts',
            breadcrumb: [{

                text: 'CatalogProducts',
            }, {
                text: 'Translation',
                active: true,
            }, ],
        },
    },

]